export const IMAGES = {
    design1: require('../assets/images/design_1.jpg'),
    design2: require('../assets/images/design_2.jpg'),
    design3: require('../assets/images/design_3.jpg'),
    logo: require('../assets/images/main-logo.jpeg'),
    avatar: require('../assets/images/user/avatar.png'),

}